module.exports = __webpack_public_path__ + "img/hic-cerebrovascular-disease-male.953de92d.png";